module.exports = __webpack_public_path__ + "static/media/tvbet.d7cf17a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/games/tvbet.jpg
// module id = 2409
// module chunks = 7